
var regMail = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/;
var regKana = /^[ァ-ンヴー]*$/;
var regHanKana = /^[ｧ-ﾝﾞﾟ\-]*$/;
var regTel = /^(0[5-9]0[0-9]{8}|0[0-9]{9})$/;
var regPostalcode = /^[0-9]{3}-[0-9]{4}$/
var regNumber = /^[0-9]+$/

const customValidator = {
  required: ((value: string, customMessage:string = '') => {
    if (value && value.length > 0) {
      return true
    } else {
      var message = "必須です。"
      if(customMessage){
        message = customMessage
      }
      return false || message
    }
  }),
  mailAddress: ((value: string) => {
    if (regMail.test(value)) {
      return true
    } else {
      return false || "有効なメールアドレスを入力してください。"
    }
  }),
  maxLength: ((value: string, maxLength: number) => {
    if (value && value.length > maxLength) {
      return false || `${maxLength}以内で入力してください。`
    } else {
      return true
    }
  }),
  isKana: ((value: string) => {
    var delSpace = value.replace(/\s/g, '')
    delSpace = delSpace.replace(/　/g, '')
    if (!regKana.test(delSpace) &&
      !regHanKana.test(delSpace)) {
      return false || "カタカナで入力してください。"
    } else {
      return true;
    }
  }),
  telNo: ((value1: string, value2: string, value3: string) => {
    if(!(value1 && value2 && value3)){
      return true;
    }
    var telNo = value1 + value2 + value3;
    if (!regTel.test(telNo)) {
      return false || "有効な電話番号を入力してください。"
    }else{
      return true;
    }
  }),
  postalcode: ((value1: string, value2: string) =>{
    if(!(value1 && value2)){
      return true;
    }
    var code = value1 + '-' + value2;
    if(!regPostalcode.test(code)){
      return false || "有効な郵便番号を入力してください。"
    }else{
      return true
    }
  }),
  requiredSearchAddress: ((prefectureCode:any, cityCode:any) => {
    if(prefectureCode && cityCode && prefectureCode != 0 && cityCode != 0){
      return true
    }else{
      return false || "郵便番号検索を実行してください。"
    }
  }),
  compareDayFromTo: ((dayFrom: string, dayTo: string) =>{
    if(!dayFrom || !dayTo){
      return true;
    }
    var dateFrom = new Date(dayFrom);
    var dateTo = new Date(dayTo)
    if(dateFrom > dateTo){
      return false || "終了日は開始日以降で入力してください。"
    }else{
      return true
    }
  }),
  compareTimeFromTo: ((timeFrom: string, timeTo: string) =>{
    if(!(timeFrom && timeTo)){
      return true;
    }
    var dateFrom = new Date(`2020/01/01 ${timeFrom}:00`)
    var dateTo = new Date(`2020/01/01 ${timeTo}:00`)
    //fromとtoの差異を分に治す
    var time = ((dateTo.getTime() - dateFrom.getTime()) / 1000 / 60 / 60)
    if(time < 1){
      return false || "勤務時間は1時間以上になるよう入力してください。"
    }else{
      return true;
    }
  }),
  isNumber: ((value: string) =>{
    if(!value){
      return true;
    }
    if(!regNumber.test(value)){
      return false || "正の整数値を入力してください。"
    }else{
      return true
    }
  }),
  maxNumber: ((value: string, max:number) =>{
    if(!value){
      return true
    }
    var numValue = parseInt(value)
    if(numValue > max){
      return false || `${max}以内で入力してください。`
    }else{
      return true
    }
  }),
  minNumber: ((value: string, min:number) =>{
    if(!value){
      return true
    }
    var numValue = parseInt(value)
    if(numValue < min){
      return false || `${min}以上で入力してください。`
    }else{
      return true
    }
  }),
  requiredIf:((value: string, target:any, cond:any) =>{
    if(target === cond && !value){
      return false || "必須です。"
    }else{
      return true;
    }
  })
}


export default customValidator; 